<template>
  <div id="price-quotation-form">
    <header>
      <p>This form composes a quotation, which you can override the value of the properties.</p>
    </header>

    <br>

    <Form ref="priceQuotationForm" :model="formData" label-position="top">

      <FormItem label="Project" prop="title" required>
        <Input placeholder="Project name" v-model='formData.title' />
      </FormItem>

      <Row :gutter="32">
        <Col span="12">
          <FormItem label="Account Comapny" required>
            <AccountCompanySelect
              v-model="formData.accounting_company_name"
              @on-select="handleSelectedCompany"></AccountCompanySelect>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="Customer">
            <Input v-model="formData.customer.name" disabled></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="Label" required>
            <Select v-model="formData.estimate_label">
              <Option value="ESTIMATE">ESTIMATE</Option>
              <!-- <Option value="QUOTATION">QUOTATION</Option> -->
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="formData.estimate_label + ' #'" prop="number">
            <Input placeholder="Estimate number" v-model='formData.estimate_number' disabled/>
          </FormItem>
        </Col>

      </Row>

      <FormItem>
        <Row :gutter="32">
          <Col span="12">
            <FormItem prop="date" label="Date" required>
              <DatePicker v-model="formData.date" format="yyyy-MM-dd"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="valid_until" label="Expire date" required>
              <DatePicker v-model="formData.valid_until" format="yyyy-MM-dd" disabled></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </FormItem>

      <Row :gutter="32">
        <Col span="12">
          <FormItem prop="currency" label="Currency" required>
            <Select v-model="formData.currency">
              <Option value="USD">USD</Option>
              <Option value="CNY">CNY</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem prop="terms" label="Terms">
            <Input v-model="formData.terms"></Input>
          </FormItem>
        </Col>
      </Row>

      <Divider orientation="left">Contact</Divider>

      <FormItem>
        <FormItem label="Select Customer Contact" style="margin-bottom: 30px" prop="contact_id">
          <Select v-model="formData.contact_id" @on-select="handleContactSelection">
            <Option v-for="contact in contacts" :key="contact.id" :value="contact.id">
              {{ getCustomerContactName(contact) }}
            </Option>
          </Select>
        </FormItem>
        <Row :gutter="32">
          <Col span="12">
            <FormItem prop="contact_first_name" label="First name">
              <Input placeholder="First name" v-model="formData.contact_first_name" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="contact_first_name" label="Last name">
              <Input placeholder="Last name" v-model="formData.contact_last_name" />
            </FormItem>
          </Col>
        </Row>
      </FormItem>
      <FormItem>
        <Row :gutter="32">
          <Col span="12">
            <FormItem prop="contact_email" label="Email">
              <Input placeholder="Email address" v-model="formData.contact_email" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="contact_phone" label="Phone">
              <Input placeholder="Phone number" v-model="formData.contact_phone" />
            </FormItem>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="Address">
        <Input v-model="formData.address" />
      </FormItem>
      <FormItem>
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="City">
              <Input v-model="formData.city" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="State">
              <Input v-model="formData.state" />
            </FormItem>
          </Col>
        </Row>
      </FormItem>
      <FormItem>
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="Postal code">
              <Input v-model="formData.postal_code" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="Country">
              <Input v-model="formData.country" />
            </FormItem>
          </Col>
        </Row>
      </FormItem>

      <Divider orientation="left">Bottom</Divider>

      <FormItem label="Additionals">
        <editor v-model="formData.additional_text" :menus="['bold', 'italic', 'underline', 'fontSize', 'foreColor', 'backColor', 'link', 'list', 'head']" valueType="html" cache></editor>
      </FormItem>

      <div class="action text-align-right">
        <Button type="primary" size="large" @click="handleSave" :loading="saving">{{ $t('save') }}</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import moment from 'moment'
import Editor from '@/components/editor'
import AccountCompanySelect from '@/components/nexpcb/form-controls/account-company-select'
import { mapActions } from 'vuex'
export default {
  name: 'QuotationMakeForm',
  components: {
    Editor,
    AccountCompanySelect
  },
  props: {
    quoteId: {
      type: Number,
      required: true
    },
    documentId: {
      type: [Number, String],
      required: false,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      loaded: false,
      saving: false,
      formData: {
        title: '',
        estimate_number: '',
        estimate_label: 'ESTIMATE',
        accounting_company_name: 'NexGroup Inc.',
        accounting_company: {

        },
        customer_id: null,
        customer: { name: '' },
        currency: 'USD',
        contact_first_name: '',
        contact_last_name: '',
        contact_email: '',
        contact_phone: '',
        address: '',
        city: '',
        state: '',
        postal_code: '',
        country: '',
        exchange_rate: 0,
        date: new Date(),
        valid_until: moment().add(2, 'months').toDate(),
        additional_text: `<h3>TERMS & CONDITIONS</h3>
        <ol>
        <li>This estimate includes XXX. (我们提供的服务内容)</li>
        <li>This estimate does not include XXX. (说明该报价不包含的内容)</li>
        <li>This estimate expire date is 14 days. If there are unforeseen objective circumstances, the quotation may be changed accordingly.</li>
        <li>The payment term standard is 100% pre-payment. (这里想说明的是付款条件默认是100% 预付。但批量的情况我们可以再谈。)</li>
        </ol>`
      },
      contacts: []
    }
  },
  mounted () {
    if (this.documentId) {
      this.getSinglePDF({ quoteId: this.quoteId, documentId: this.documentId }).then(resp => {
        this.formData = resp.data
        this.loadQuote(this.quoteId).then(resp => {
          this.$set(this.formData, 'customer', resp.data.customer || { name: '' })
          this.contacts = resp.data.customer.company.contacts
        })
      })
    } else {
      this.loadData()
    }
  },
  methods: {
    ...mapActions([
      'createSinglePDF',
      'updateSinglePDF',
      'loadQuote',
      'getSinglePDF'
    ]),
    loadData() {
      this.loadQuoteData()
    },
    loadQuoteData: function () {
      this.loading = true
      this.loadQuote(this.quoteId).then(resp => {
        this.loaded = true

        if (resp.data.customer) {
          this.formData.customer = resp.data.customer
        } else {
          this.formData.customer = { name: '' }
        }
        this.formData.title = resp.data.title
        this.formData.currency = resp.data.currency
        this.formData.customer_id = resp.data.customer_id
        this.formData.exchange_rate = resp.data.exchange_rate
        this.formData.estimate_number = resp.data.number
        this.formData.valid_until = resp.data.expires_date
        this.formData.terms = resp.data.payment_term
      }).catch(() => {
        this.loaded = false
      }).finally(() => {
        this.loading = false
      })
    },
    handleSelectedCompany(company) {
      this.formData.accounting_company_address = company ? company.address : null
    },
    handleSave: function () {
      this.$refs['priceQuotationForm'].validate((valid) => {
        if (valid) {
          let formData = _.clone(this.formData)
          formData.customer_id = this.formData.customer ? this.formData.customer.id : null
          formData.date = moment(this.formData.date).format('YYYY-MM-DD').toString()
          formData.valid_until = moment(this.formData.valid_until).format('YYYY-MM-DD').toString()
          this.saving = true
          if (!this.documentId) {
            this.createSinglePDF({ quoteId: this.quoteId, data: formData }).then(resp => {
              this.$Message.success('Price quotation has been created!')
              this.formData.documentId = resp.data.id
              this.$emit('on-saved', this.formData, false)
            }).finally(resp => { this.saving = false })
          } else {
            this.updateSinglePDF({ quoteId: this.quoteId, documentId: this.documentId, data: formData }).then(resp => {
              this.$Message.success('Price quotation has been updated!')
              this.formData.documentId = resp.data.id
              this.$emit('on-saved', this.formData, false)
            }).finally(resp => { this.saving = false })
          }
        } else {
          this.$Message.error('You have error in the form, please correct them first before submitting.')
        }
      })
    },
    getCustomerContactName (contact) {
      return `${contact.firstname} ${contact.lastname}`
    },
    handleContactSelection(selected) {
      let contact = this.contacts.find(contact => contact.id === selected.value)
      this.formData.contact_first_name = contact.firstname || this.formData.firstname
      this.formData.contact_last_name = contact.lastname || this.formData.lastname
      this.formData.contact_email = contact.email || this.formData.email
      this.formData.contact_phone = contact.contact_phone || this.formData.contact_phone
      this.formData.country = contact.country || this.formData.country
      this.formData.address = contact.address || this.formData.address
      this.formData.city = contact.city || this.formData.city
      this.formData.state = contact.state || this.formData.state
      this.formData.postal_code = contact.postal_code || this.formData.postal_code
    }
  },
  watch: {
    quoteId: function () {
      this.loadQuoteData()
    }
  }
}
</script>

<style lang="less">
.w-e-toolbar { clear: both; }
</style>
